import { render } from "./Serve.vue?vue&type=template&id=9d30416e"
import script from "./Serve.vue?vue&type=script&lang=js"
export * from "./Serve.vue?vue&type=script&lang=js"
script.render = render

export default script